import { DateTime, Duration } from 'luxon';
import { isString, isNop, toNop } from '../common/mod.js';
const DATETIME_ZONE_OPTIONS = { zone: 'UTC' };
const NOP_DATETIME_OPTIONS = { year: 1970, month: 1, day: 1, hour: 0, minute: 0, millisecond: 0 };
export const nopDateTime = toNop(DateTime.fromObject(NOP_DATETIME_OPTIONS, DATETIME_ZONE_OPTIONS));
export function createDateTime(options) {
    return DateTime.local(options);
}
const TO_DATE_OPTIONS = { setZone: true };
export function toDate(value) {
    if (isString(value)) {
        value = DateTime.fromISO(value, TO_DATE_OPTIONS).startOf('day');
    }
    if (!value) {
        return value;
    }
    return value?.isValid ? value : undefined;
}
export function toDateTime(value, options) {
    if (isString(value)) {
        value = DateTime.fromISO(value, options);
    }
    if (!value) {
        return value;
    }
    return value?.isValid ? value : undefined;
}
const MERGE_TIME_OPTIONS = { setZone: false };
export function mergeDateTime(date, time) {
    if (isString(time)) {
        time = DateTime.fromFormat(time, 'HH:mm:ss', MERGE_TIME_OPTIONS);
    }
    if (!time?.isValid) {
        return undefined;
    }
    date = toDate(date);
    if (!date) {
        return undefined;
    }
    return date.set({ hour: time.hour, minute: time.minute, second: time.second, millisecond: time.millisecond });
}
export function toDuration(value, options) {
    if (isString(value)) {
        value = Duration.fromISO(value, options);
    }
    if (!value) {
        return value;
    }
    return value.isValid ? value : undefined;
}
export function toIsoDate(value) {
    return !value || isNop(value) || !value.isValid ? undefined : (value.toISODate() ?? undefined);
}
export function toIsoTime(value) {
    return !value || isNop(value) || !value.isValid ? undefined : (value.toISOTime() ?? undefined);
}
export function toIsoDateTime(value) {
    return !value || isNop(value) || !value.isValid ? undefined : (value.toISO() ?? undefined);
}
export function toIsoDuration(value) {
    return !value || isNop(value) || !value.isValid ? undefined : (value.toISO() ?? undefined);
}
export * from 'luxon';
//# sourceMappingURL=date_time.js.map